import axios from "axios";

export function chargeStripe(body) {
  const sk = process.env.VUE_APP_STRIPE_SK;
  const config = {
    baseURL: `https://api.stripe.com/v1/`,
    headers: {
      Authorization: `Bearer ${sk}`,
      "Content-Type": "application/x-www-form-urlencoded"
    }
  };
  return axios.post("charges", body, config);
}
